// const configData = useConfig();
const PageRoutes = {
  Login: "/sign-in", // alias of SignIn; kept so existing PrivateRoute redirects still resolve (see App.tsx)
  SignIn: "/sign-in",
  DashBoard: "/dashboard",
  ContactUS: "/contact-us",
  PlayerAlerts: "/admin/player-alerts",
  Whizzard: "/admin/whizzard",
  Media: "/admin/media",
  Ads: "/admin/ads",
  ShortView: "/short-view/:id",
  Clips: "/clips",
  ClipView: "/clip-view/:id",
  FilterClips: "/clips/:type",
  HighLightPlayer: "/highlight-player",
  Reports: "/admin/reports",
  ShortContent: "/highlights",
  GameView: "/admin/game-view/:id",
  FilterShortContent: "/short-content/:channel/:type_name/:id/:type",
  Polls: "/admin/polls",
  EditAds: "/admin/ads/:id",
  Team: "/team",
  EditPolls: "/admin/polls/:id",
  Rules: "/admin/rules",
  Games: "/admin/games",
  ChannelScheduler: "/admin/scheduler",
  EditWhizzard: "/admin/whizzard/:id",
  MediaCreate: "/admin/media/:id",
  RulesView: "/admin/rules/:id",
  EditPlayerAlerts: "/admin/player-alerts/edit/:id",
  HomePage: "/",
  Any: "/*",
  Admin: "/admin/announcement",
  GiftPage: "/buy-gift",
  CancelSaveFlow: "/plans-and-subscription",
  RedeemGiftPage: "/redeem-gift/:token",
  SecondScreen: "/second-screen",
  SliderSetting: "/admin/slider",
  EditSliderSetting: "/admin/slider/:id",
  EditAnnouncement: "/admin/announcement/:id",
  UserView: "/admin/user/:id",
  Register: "/create-account",
  AccountPage: "/account",
  Packages: "/plans",
  UpcomingEvent: "/upcoming-event",
  LiveTV: "/na-24x7",
  ChatAPP: "/chat-app",
  OnDemand: "/vod",
  VerifyEmail: "/emailVerify",
  Users: "/admin/users",
  GameSummary: "/admin/game-summary",
  Onboard: "/onboard",
  FavoritesManager: "/favorites-manager",
  Lens: "/lens",
  LensUniverse: "/lens/universe",
  LensStudio: "/lens/studio",
  LensFavorites: "/lens/favorites",
  WatchHistory: "/watch-history",
  MyWatchParties: "/watch-parties",
  PurchaseHistoryPage: "/purchase-history",
  Billing: "/billing",
  Devices: "/devices",
  NotificationSettings: "/notification-settings",

  WatchParty: "/watch-party",
  EmailEditor: "/email-editor",
  EditProfile: "/profile/edit-profile",
  PasswordReset: "/resetPassword",
  TermAndConditions: "/term-conditions",
  PrivacyPolicy: "/privacy-policy",
  Watch: "/watch/:gameId",
  Setting: "/profile-information",
  AccountSettings: "/account-settings",
  paymentPage: "/payment/:clientSecret/:plan_id/:paymentId",
  Alert: "/notification",
  MyNAHLTV: "/spotlight/build/:id/:channel_id",
  PersonalChannel: "/spotlight/:id",
  AcceptChannelShare: "/spotlight-share/accept/:token",
  DeclineChannelShare: "/spotlight-share/decline/:token",
};

/**
 * The channel-era URLs these four replaced, still routed so old links work.
 *
 * Not dead weight: a share invitation lives in somebody's inbox for seven
 * days (ExpiresAt is set to now + 7 days when the invite is created), and
 * anyone who bookmarked their channel kept a /personal-channel link
 * indefinitely. App.tsx points each of these at LegacyRedirect, which
 * carries the path params and query string across.
 */
export const LegacyPageRoutes = {
  MyNAHLTV: "/my-channel/:id/:channel_id",
  PersonalChannel: "/personal-channel/:id",
  AcceptChannelShare: "/channel-share/accept/:token",
  DeclineChannelShare: "/channel-share/decline/:token",
};

export const APIRoutes = {
  RefreshToken: "/refreshToken",
  Logout: "/logout",
  ChannelScheduleAdmin: "/admin/channel-schedule",
  ChannelScheduleAdminDay: "/admin/channel-schedule/:channelId/:date",
  ChannelScheduleDay: "/channel-schedule/:date",
  ChannelSchedulePlayback: "/channel-schedule/playback/:channelId",
  AdminUploads: "/admin/uploads",
  CondensedGame: "/checkCondenced",
  GetGeoIp: "/getGeoIp",
  GetWhizzardByIDVideoStats: "/videoStats/:id",
  LikeDisLike: "/videoReaction/:entity_id/:entity_name",
  LikeClip: "/linius/content/:contentId/like",
  DisClip: "/linius/content/:contentId/unlike",
  GetWhizzardByIDVideoViews: "/videoViews/:entity_id/:entity_name",
  CreateSubscription: "/createSubscription",
  GetRuleById: "/getRuleById/:id",
  CreateRule: "/createRule",
  GetCountryList: "/getCountryList",
  GetRuleList: "/getRuleList",
  UpdateRuleAdmin: "/updateGameSetting/:game_id",
  UpdateRule: "/updateRule/:id",
  UpdateGameSummary: "/updateGameSummary/:id",
  GenerateGameSummary: "/generateGameSummary/:gameId",
  GenerateGameSummaryShort: "/generateGameSummaryShort",
  UpdateWhizzardByGameID: "/updateWhizzardByGameID/:gameId",
  SaveGameSummary: "/saveGameSummary/:id",
  UnPublishWhizzard: "/unPublishWhizzard/:id",
  PublishWhizzard: "/publishWhizzard/:id",
  DeleteWhizzard: "/deleteWhizzard/:id",
  DeleteGameSummary: "/deleteGameSummary/:id",
  GetWhizzards: "/getWhizzards",
  GetGameSummaryByGameId: "/getGameSummaryByGameId/:gameId",
  GetWhizzardsV2: "/v2/getWhizzards",
  RegenerateWhizzard: "/regenerateWhizzard/:id",
  GetWhizzardsAdmin: "/getWhizzardsAdmin",
  CastVote: "/castVote/:id",
  CreateMedia: "/createMedia",
  CreateWhizzard: "/createWhizzard",
  GetUserViewerShipReport: "/getViewReportByUserId/:id",
  GetGameSummaryAdmin: "/getGameSummary",
  UnPublishAd: "/unPublishAd/:id",
  UpdateTenantConfig: "/updateTenantConfig",
  PublishMedia: "/publishMedia/:id",
  UnpublishMedia: "/unpublishMedia/:id",
  UpdateWhizzardByID: "/updateWhizzardByID/:id",
  DeleteMedia: "/deleteMedia/:id",
  PublishAd: "/publishAd/:id",
  DeleteAd: "/deleteAdById/:id",
  GetAdDetailsByID: "/getAdbyID/:id",
  GetWhizzardByID: "/getWhizzardByID/:id",
  GetExploreContent: "/linius/content/explore",
  GetCondencedGameLinius: "/linius/content/profile/:id",
  ContentByID: "/linius/content/:id",
  ContentStats: "/linius/content/:id/stats",
  GetFollowingContent: "/linius/content/following",
  GetClipList: "/linius/content/:type",
  GetTrendingContent: "/linius/content/trending",
  GetLatestPopularContent: "/linius/content/popular",

  ApplyCouponToSubscription: "/applyCouponToSubscription",
  ApplyCodeUpgrade: "/applyCodeUpgrade",
  RetrivePendingPrice: "/retrivePendingPrice",

  GetErrorMessagesByID: "/getErrorMessagesByID/:id",
  UpdateErrorMessageByID: "/updateErrorMessageByID/:id",
  UpdatePollByID: "/updatePollByID/:id",

  GetUserAccountDetails: "/getUserAccountDetails",
  CreateAd: "/uploadAdVideo",
  UpdateAd: "/updateAdVideo/:id",

  GetPaymentMethod: "/getPaymentMethod",
  UnPublishPlayerError: "/unPublishErrorMessgae/:id",
  CreateErrorMessage: "/createErrorMessage",
  PublishPlayerError: "/sendMessage/:id",
  GetPollByID: "/getPollById/:id",
  GetPoll: "/getPolls",
  PublishPoll: "/publishPoll/:id",
  UnPublishPoll: "/unPublishPoll/:id",
  DeletePoll: "/deletePoll/:id",
  CreatePoll: "/createPoll",
  GetPollByGameID: "/getPollByGameID",
  GetUserDownloadCredit: "/getUserDownloadCredit",
  DeleteErrorMessage: "/deleteErrorMessage/:id",
  GetCurrentActiveAd: "/getCurrentActiveAd",
  GetAllLinusDownloadVideo: "/getAllLinusDownloadVideo",
  GetAllErrorMessages: "/getAllErrorMessages",
  DeactivateUser: "/deactivateUser/:id",
  DeleteUsersSub: "/deleteUsersSubscription/:id",
  CheckIsVoteGiven: "/checkIsVoteGiven/:id",
  CustomerPortal: "/customer-portal",
  JoinParty: "/joinParty",
  GetAllAds: "/getAllAds",
  getMediaList: "/getMediaList",
  GetRoles: "/getRoles",
  UpdateUserRole: "/updateUserRole/:id",
  UpdateUserPassword: "/updateUserPassword/:id",
  ApplyGiftCode: "/applyGiftCode",
  updateAllSlider: "/updateAllSlider/:status",
  CreateGiftSubscription: "/gift-subscription",
  GiftSubscriptionOptions: "/gift-subscription/options",
  GetGiftSubscriptionDetails: "/gift-subscription/:id",
  GetGiftRedeemInfo: "/gift-subscription/redeem/:token",
  RedeemGiftSubscription: "/gift-subscription/redeem/:token",
  MyGiftEntitlement: "/gift-subscription/mine",
  GiftSubscriptionInbox: "/gift-subscription/inbox",
  GiftSubscriptionRecipientStatus: "/gift-subscription/recipient-status",
  GiftSubscriptionSent: "/gift-subscription/sent",
  ResendGiftSubscription: "/gift-subscription/:id/resend",
  GetUsersEmailDetails: "/getUsersEmailDetails/:id",
  GetUsersFavoriteTeam: "/getUsersFavouriteTeam",
  CreateOrUpdateUserFavoriteTeam: "/createOrUpdateUserFavouriteTeam",
  GetMessageByGameID: "/getErrorMessagesByGameID",
  GetListOfNotification: "/getListOfNotification",
  GetListOfNotificationByID: "/getListOfNotification/:id",
  EditNotification: "/editNotification/:id",
  PublishNotification: "/publishNotification/:id",
  DeleteNotification: "/deleteNotification/:id",
  GetUserAllDownloadedVideoClipsByUserID:
    "/getUserAllDownloadedVideoClipsByUserID/:id",
  // The one route in here served by the Audience Layer, not by the tenant, so
  // it is joined to VITE_AUDIENCE_LAYER_API_URL rather than to the tenant base
  // url every other entry assumes. `:id` is the tenant UserID, which is the
  // external user id the layer keys a fan's downloads on.
  AudienceLayerAdminUserDownloads: "/admin/users/:id/downloads",
  GetUserAllVideoClips: "/getUserAllVideoClips",
  getUserAllDownloadedVideoClips: "/getUserAllDownloadedVideoClips",
  DownloadClips: "/downloadClips",
  DownloadClipsV2: "/downloadClipsV2",
  GetHomeSlider: "/getHomeSlider/:id",
  UpdateHomeSlider: "/home-slider-update/:id",
  UnPublishNotification: "/unPublishNotification/:id",
  UnPublishSlider: "/unPublishSlider/:id",
  PublishSlider: "/publishSlider/:id",
  CreateNotification: "/createNotification",
  getUserDownloadCredit: "/getUserDownloadCredit",

  SubscribePlan: "/create-checkout-session",
  CheckSubscribe: "/is-user-subscription-active",
  GetSubscriptionDetials: "/get-user-subscription-details",
  SubscriptionStatus: "/subscription-status",
  GetCurrentSubscriptionDetials: "/get-user-current-subscription-details/:id",
  CheckCustomerExistOrNot: "/checkCustomerExistOrNot",
  GetAllUser: "/getAllUsers",
  GetViewReport: "/getViewReport",
  EditProfile: "/editprofile",
  EmailPreferences: "/email-preferences",
  CreateChannel: "/createChannel",
  ChangePassword: "/changePassword",
  GetVideoDetails: "/getVideoDetails",
  GetAnalyticsUrl: "/getAnalyticsUrl/:key",

  GetVideoUrl: "/getVideoUrl",
  GetAllThumbnais: "/getAllThumbnails",
  CreteDownloadVideo: "/creteDownloadVideo",
  CreteDownloadVideoInLive: "/creteDownloadVideoInLive",
  CreateCondensedGameDownload: "/createCondensedGameDownload",
  GetCondensedGameDownload: "/getCondensedGameDownload",
  UpdateChannel: "/updateChannel/:id",
  GetChannel: "/getChannel/:id",
  GetAllChannel: "/getAllChannel",
  GetChannelList: "/getChannelList",
  GetChannelStats: "/getChannelStats",
  DeleteChannel: "/deleteChannel/:id",
  ShareChannel: "/shareChannel",
  GetMyShareRequests: "/getMyShareRequests",
  AcceptChannelShare: "/acceptChannelShare/:token",
  DeclineChannelShare: "/declineChannelShare/:token",
  CancelChannelShare: "/cancelChannelShare/:shareId",
  GetChannelShares: "/getChannelShares",
  GetVideoList: "/getVideoList/:page/:id",
  StartParty: "/startWatchParty",
  Slider: "/home-slider/active",
  GetAllSlider: "/home-slider/all",
  DeleteSliderById: "/delete-home-slider/:id",
  UpdatePaymentMethod: "/updatePaymentMethod",
  GetPaymentHistory: "/getPaymentHistory/:id",
  GetClientSecret: "/getClientSecret",
  GetToken: "/getTokenIVS",
  CreateIntent: "/create-payment-intent",
  SignIn: "/signin",
  InviteSend: "/sendUserInvite",
  PostClipDetailas: "/userVideoClips",
  ShareClipDetailas: "/shareVideoClip",
  PostVideoAnalyse: "/createVideoAnalyse",
  GetVideoClipsDetails: "/getUserVideoClips/:id",
  CustomerSubscriptionHistory: "/customer-subscription-history",
  GoogleSignIn: "/googleauth",
  Login: "/login",
  Register: "/register",
  VerifyEmail: "/verify-email",
  ResetPassword: "/setpassword",
  ForgotPassword: "/forgotpassword",
  SendResetPasswordEmailById: "/sendResetPasswordEmailById/:id",
  UpdateUserDownloadCredit: "/updateUserDownloadCredit/:id",
  GetUserDownloadTokensById: "/getUserDownloadTokensById/:id",
  GetUserDetailsById: "/getUsersByID/:id",
  ChannelOption: "/channel/:id",
  GetEventsAdmin: "/events",
  GetTeamsAdmin: "/teams/:customer",
  Team: `/team/:customer/:id`,
  AllTeamsByCustomer: "/team/:customer",
  CreateSlider: "/create-home-slider",
  getTenantConfig: "/getTenantConfig",
  HighLights: "/highlight/:id",
  GetTeamHighLights: "/getGoals/:id/:value/:teamData/:action/:page",
  CreateMeeting: "/createMeeting?",
  GetAttendee: "/getAttendee?",
  TeamEventsList: "/schedule",
  AdminScheduleList: "/admin-schedule",
  SendMeetingInvite: "/sendMeetingInvite",
  GetPlans: "/getPlans",
  GetPlansByID: "/getPlanDetailsById/:id",
  GameDetails: "/player",
  CreateRoom: "/createRoom",
  GetLogs: "/getLogs",
  GetLogsCount: "/getLogsCount",
  GetHSHighLights: "/v2/search",
  CondensedGameClips: "/v1/condensed-game-clips",
  AssemblyClips: "/v1/assembly-clips",
  /**
   * One game by its SEARCH SERVICE id, on the shared team host rather than a
   * tenant api_url. GameDetails ("/player") keys on the tenant's own game id;
   * this keys on game_id_tpe, which is the only game id an analytics clip
   * carries. Scope it with ?customer=.
   */
  GameDetailsByTpeId: "/game-details/:id",
  MarkAllRead: "/markAllRead",
  MarkAllReadAnnoucement: "/markAllReadAnnoucement",
  GameLogsAdd: "/gameLogAdd",
  UploadImage: "/uploadImage",
  UpdateLogs: "/updateLogs/:id",
  UpdateLogsAnnoucement: "/updateAnnouncement/:id",
  AppyCode: "/applyCode",
  ChangePlanDetails: "/cancelSubscription",
  GetSaveOffers: "/retention/save-offers",
  ResendInvite: "/resendEmailInvite",
  GetAllTeams: "/getAllTeams",
  GetSeasons: "/seasons",
  GetPlayesNameByTeamsName: "/getPlayesNameByTeamsName",
  PauseSubscription: "/pauseSubscription/:id",
  GetEvents: "/getEvents",
  GetPaymentLogs: "/getPaymentLogs",
  GetAllTeamsHTP: "/v1/get-all-teams",
  GetAllPlayersHTP: "/v1/get-all-players",
  GetAllVideoHTP: "/v2/search",
};

export const CANCEL_REASONS = {
  TOO_EXPENSIVE: "too_expensive",
  OFF_SEASON: "off_season",
  NOT_WATCHING: "not_watching",
  TECHNICAL: "technical",
  OTHER: "other",
} as const;

export type CancelReasonValue =
  (typeof CANCEL_REASONS)[keyof typeof CANCEL_REASONS];

export const SAVE_FLOW_GA_EVENTS = {
  OFFER_SHOWN: "save_flow_offer_shown",
  OFFER_SELECTED: "save_flow_offer_selected",
  PAUSE: "save_flow_pause",
  SEASONAL_HOLD: "save_flow_seasonal_hold",
  DOWNGRADE: "save_flow_downgrade",
} as const;

export const UserRoles = {
  USER: 1,
  HTP_ADMIN: 2,
  TEAM_ADMIN: 3,
  LEAGUE_ADMIN: 4,
  FREE_WATCH: 5,
  FREE_WATCH_D: 6,
  CUSTOMER_ADMIN: 7,
};
export const UserPermissions = {
  reguler: "reguler",
  watch: "watch",
  download: "download",
};

export const WHIZZARD_TYPE = {
  1: "custom",
  2: "goals",
  3: "condensed games",
};
export const USERROLE = [
  {
    name: "SUPERADMIN",
    id: 2,
    permissitions: ["normal", "stopwatch", "slider"],
  },
  {
    name: "GAME_MONITOR",
    id: 8,
    permissitions: ["normal", "stopwatch"],
  },
  {
    name: "LEAGUE_ADMIN",
    id: 1,
    permissitions: ["normal", "slider"],
  },
];
export const CATEGORY = [
  { key: "Goal", value: "goal" },
  { key: "Shot", value: "shot" },
  { key: "Save", value: "save" },
  { key: "Highlight", value: "highlight" },
  { key: "Faceoff", value: "faceoff" },
  { key: "Hit", value: "hit" },
  { key: "Penalty", value: "penalty" },
  { key: "Custom", value: "custom" },
];
export const getUrl = (url: string) => {
  const urlObj = new URL(url);
  // Get query parameters
  const assetID = urlObj.searchParams.get("id")?.split(",")?.[1]; // 'JohnDoe'
  const time = 1595700;
  return `https://middleware.lvs.linius.com/playback/poster/${assetID}?ts=${time}&size=720p`;
};
export const INSIDER_PLAN_ID = 2;

// HTPTV-683: subscription plan tiers. PAY_AS_YOU_GO (single-game) is a one-time
// purchase, NOT a subscription tier.
export const PLAN_TYPE = {
  BASIC: 1,
  INSIDER: 2,
  PAY_AS_YOU_GO: 3,
} as const;
export default PageRoutes;
